// extracted by mini-css-extract-plugin
module.exports = {"clearFilters":"clear-filters-button-module__clearFilters___204He"};